export const useLogo = {
  methods: {
    getLogo(data) {
      let result = '';
      if (data === 'mytarget') {
        result = require('@/assets/icons/icon-mytarget-logo.svg');
      } else if (data === 'vkontakte') {
        result = require('@/assets/icons/icon-vkontacte.svg');
      } else if (data === 'avito') {
        result = require('@/assets/icons/icon-avito.svg');
      } else if (data === 'vkads') {
        result = require('@/assets/icons/icon-vkreklama.svg');
      } else if (data === 'facebook') {
        result = require('@/assets/icons/icon-meta.svg');
      } else if (data === 'yandex') {
        result = require('@/assets/icons/yandex-direct-icon.svg');
      } else if (data === 'yandexbusiness') {
        result = require('@/assets/icons/icon-yandex-business.png');
      } else if (data === 'google') {
        result = require('@/assets/icons/icon-google.svg');
      } else if (data === 'tiktok') {
        result = require('@/assets/icons/icon-tiktok.svg');
      } else if (data === 'telegram') {
        result = require('@/assets/icons/icon-telegram.svg');
      } else if (data === 'promopages') {
        result = require('@/assets/icons/icon-promo-page.jpeg');
      } else if (data === 'mediaplatform') {
        result = require('@/assets/icons/icon-media.png');
      } else if (data === 'vkadblogger') {
        result = require('@/assets/icons/icon-vkadblogger.svg');
      } else if (data === 'rbk') {
        result = require('@/assets/icons/icon-rbk.png');
      } else if (data === 'roxot') {
        result = require('@/assets/icons/icon-roxot.jpeg');
      } else if (data === 'onetarget') {
        result = require('@/assets/icons/icon-onetarget.png');
      } else if (data === 'soloway') {
        result = require('@/assets/icons/icon-soloway.svg');
      } else if (data === 'hybrid') {
        result = require('@/assets/icons/icon-hybrid.png');
      } else if (data === 'mts_sms' || data === 'mts_dsp') {
        result = require('@/assets/icons/icon-mts.svg');
      } else if (data === 'rutube') {
        result = require('@/assets/icons/icon-rutube.png');
      } else if (data === 'ivi') {
        result = require('@/assets/icons/icon-ivi.svg');
      } else if (data === 'kinopoisk') {
        result = require('@/assets/icons/icon-kinopoisk.svg');
      } else if (data === 'tj') {
        result = require('@/assets/icons/icon-tj.png');
      } else if (data === 'astra_lab') {
        result = require('@/assets/icons/icon-astra-lab.png');
      } else if (data === 'urbanads') {
        result = require('@/assets/icons/icon-urban-ads.png');
      }
      return result;
    },
  },
};
